// extracted by mini-css-extract-plugin
var _1 = "ProfileTabContent__alex--QJSXE";
var _2 = "ProfileTabContent__avatar--kn7hw general__shadow--ifbUf";
var _3 = "ProfileTabContent__avatarEdit--YZ9Sr";
var _4 = "ProfileTabContent__displayName--RAwg3";
var _5 = "ProfileTabContent__displayNameBG--Wg2zd general__bg--twM_t";
var _6 = "ProfileTabContent__displayNameQuad--JuW1k";
var _7 = "ProfileTabContent__grogg--JnW7f";
var _8 = "ProfileTabContent__lizzie--jtv3U";
var _9 = "ProfileTabContent__main--sdQ8B";
var _a = "ProfileTabContent__winnie--tc64f";
export { _1 as "alex", _2 as "avatar", _3 as "avatarEdit", _4 as "displayName", _5 as "displayNameBG", _6 as "displayNameQuad", _7 as "grogg", _8 as "lizzie", _9 as "main", _a as "winnie" }
